import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const PrestasiService = {}

PrestasiService.getData = function (token,id_pendaftar) {

    return fetch({
        url: '/transaksi/prestasi/data',
        method: 'get',
        params: {
            id_pendaftar
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}


PrestasiService.post = function (token,data) {
    return fetch({
        url: '/transaksi/prestasi/store',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PrestasiService.delete = function (token,data) {
    return fetch({
        url: '/transaksi/prestasi/delete',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PrestasiService.update = function (token,data) {
    return fetch({
        url: '/transaksi/prestasi/update',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}


export default PrestasiService;
